/**
 * The graphql-api a localhost dev server talks to directly. `pnpm stack:*`
 * (scripts/dev-stack.mjs) sets VITE_LOCAL_API_ORIGIN when it had to put the API on
 * another port; plain `vite` keeps http://localhost:3000.
 */
export const LOCAL_API_ORIGIN: string =
  import.meta.env.VITE_LOCAL_API_ORIGIN || 'http://localhost:3000';

export const LOCAL_API_WS_ORIGIN = LOCAL_API_ORIGIN.replace(/^http/, 'ws');
